<script lang="ts">
	import { AlertTriangle } from 'lucide-svelte';

	import * as Alert from './ui/alert';
	import { Button } from './ui/button';
</script>

<div class="flex-justify-center">
	<Alert.Root variant="destructive">
		<AlertTriangle class="size-4" />
		<Alert.Title>Database error</Alert.Title>
		<Alert.Description class="grid gap-3">
			<p>An error occurred while setting up your private database.</p>
			<div class="flex justify-center">
				<Button variant="outline" href="/settings/data">View error details</Button>
			</div>
		</Alert.Description>
	</Alert.Root>
</div>
